/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
 */
import pluginFactory from 'taoTests/runner/plugin';
import PreviewerNavigator from './PreviewerNavigator.svelte';

/**
 * the previewer navigator plugin handles:
 *  - the next/previous buttons
 *  - the progress visualization
 */
export default pluginFactory({
    name: 'previewerNavigator',

    init() {
        const testRunner = this.getTestRunner();
        testRunner
            .on('enablenav', () => {
                this.enable();
            })
            .on('disablenav', () => {
                this.disable();
            });
    },

    render() {
        const testRunner = this.getTestRunner();
        const areaBroker = testRunner.getAreaBroker();
        const testConfig = testRunner.getConfig();

        this.navigator = new PreviewerNavigator({
            target: areaBroker.getNavigationArea(),
            props: {
                serviceCallId: testConfig.serviceCallId,
                disabled: true
            }
        });

        this.navigator.$on('move', e => {
            const { direction, scope, position } = e.detail;
            if (direction === 'next') {
                testRunner.next(scope);
            } else if (direction === 'previous') {
                testRunner.previous(scope);
            } else {
                if (testRunner.getTestContext().itemPosition !== position) {
                    testRunner.jump(position);
                }
            }
        });
    },

    enable() {
        if (this.navigator) {
            this.navigator.$set({ disabled: false });
        }
    },

    disable() {
        if (this.navigator) {
            this.navigator.$set({ disabled: true });
        }
    },

    destroy() {
        if (this.navigator) {
            this.navigator.$destroy();
        }
    }
});
